<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadBrandList'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="brandList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="品牌代码" prop="code"></el-table-column>
      <el-table-column label="品牌名称" prop="name"></el-table-column>
      <el-table-column label="状态" width="60">
        <template #default="{row}">
          <div>{{row.status | status}}</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column width="80" align="center">
        <template #header>
          <el-button v-if="addable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="edit(row)" size="mini">{{readOnly ? '查看' : '编辑'}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 50]"
        :page-size="page.size"
        layout="sizes, total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

    <edit-brand-dialog :visible.sync="dialog.show" :brand="dialog.brand" :read-only="readOnly"></edit-brand-dialog>
  </div>
</template>

<script>
  import EditBrandDialog from '@/views/car/brand/EditBrandDialog'
  import { Brand } from '@/store/objdef/objectDef'
  import authority from '@/utils/authority'

  export default {
    name: 'BrandList',
    components: { EditBrandDialog },
    data () {
      return {
        loading: false,
        searchText: null,
        dialog: {
          show: false,
          brand: new Brand()
        },
        page: {
          size: 10,
          current: 1
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('brand/all').finally(() => {
          this.loading = false
        })
      },
      add () {
        this.dialog.brand = new Brand()
        this.dialog.show = true
      },
      edit (brand) {
        this.dialog.brand = this.$_.cloneDeep(brand)
        this.dialog.show = true
      },
      deleteBrand (brand) {
        this.$confirm(`确认删除品牌【${brand.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('brand/delete', brand).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      },
      handleSizeChange (val) {
        this.page.size = val
      },
      handleCurrentChange (val) {
        this.page.current = val
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadBrandTemplate'
      },
      activeBrandList () {
        const list = this.$store.state.brand.brandList

        if (!this.searchText) return list
        return list.filter(brand => brand.name.indexOf(this.searchText) !== -1)
      },
      brandList () {
        const begIndex = this.page.size * (this.page.current - 1)
        return this.activeBrandList.slice(begIndex, begIndex + this.page.size)
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_BRAND)
      },
      addable () {
        return this.$hasPermission(authority.ADD_BRAND)
      },
      totalCount () {
        return this.activeBrandList.length
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
